import React, { useState } from 'react';
const faqs = [{
  q: 'Wie erhalte ich das Material?',
  a: 'Sofort nach dem Kauf erhältst du einen Link zum Download aller PDFs in dein E-Mail-Postfach.'
}, {
  q: 'Ist es für Hobbyligen oder nur für die Jugend geeignet?',
  a: 'Es deckt alles ab: Von den psychomotorischen Grundlagen der U10 bis hin zu komplexen 5-1 Systemen für den Leistungsbereich.'
}, {
  q: 'Kann ich die Karten ausdrucken?',
  a: 'Ja, alle Dateien sind für den Druck in hoher Qualität (A4) optimiert.'
}, {
  q: 'Funktioniert es auch für Trainer mit wenig Erfahrung?',
  a: 'Absolut. Das Kit ist sowohl für erfahrene Trainer als auch für Einsteiger gedacht. Die Trainingspläne sind sofort einsatzbereit und die Progressionen werden Schritt für Schritt erklärt.'
}, {
  q: 'Kann ich das Material auf mehreren Geräten nutzen?',
  a: 'Klar! Nach dem Kauf kannst du auf das Material von jedem Gerät aus zugreifen: Computer, Tablet oder Smartphone. Die Dateien sind im PDF-Format und mit allen Geräten kompatibel.'
}, {
  q: 'Wie funktioniert die 7-Tage-Garantie?',
  a: 'Wenn du aus irgendeinem Grund nicht mit dem Kit zufrieden bist, schreibst du uns einfach innerhalb von 7 Tagen nach dem Kauf und wir erstatten dir 100% des Betrags zurück, ohne Fragen. Null Risiko für dich.'
}, {
  q: 'Welche Altersgruppen werden abgedeckt?',
  a: 'Das Kit deckt alle Altersgruppen ab: von U10 bis zum Erwachsenenbereich. Jede Übung ist mit klaren Hinweisen zur altersgerechten Anpassung versehen, sodass du sie an dein Team anpassen kannst.'
}, {
  q: 'Brauche ich spezielle Materialien oder Geräte?',
  a: 'Nein. Alle Übungen sind so konzipiert, dass sie mit Standard-Volleyballausrüstung (Bälle, Netz, Hütchen) durchführbar sind. Es werden keine teuren Spezialgeräte benötigt.'
}, {
  q: 'Wie viele Trainingseinheiten sind enthalten?',
  a: 'Das Kit enthält über 100 sofort einsatzbereite Übungen und mehr als 50 komplette Trainingseinheiten, die du direkt auf den Platz mitnehmen kannst – genug Material für eine ganze Saison.'
}, {
  q: 'Gibt es Updates für das Material?',
  a: 'Ja! Du erhältst lebenslangen Zugriff auf alle zukünftigen Updates und Erweiterungen des Kits – komplett kostenlos. Einmal kaufen, für immer profitieren.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-89">
          Häufig gestellte Fragen
        </h2>

        <div className="space-y-4 mb-16" data-id="element-90">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(37,99,235,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-91">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-92">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-93">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-94">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-95">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-96">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-97">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)'
        }} data-id="element-98"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-4 w-full sm:w-auto max-w-2xl text-gray-900 shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-99">
            💪 JA! ICH WILL MEINE TRAININGS JETZT REVOLUTIONIEREN
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-100">
            <span data-id="element-101">⚡ Sofortiger Zugriff</span>
            <span data-id="element-102">•</span>
            <span data-id="element-103">🛡️ 7 Tage Garantie</span>
          </p>
        </div>
      </div>
    </section>;
}